import DossierDetailClarification from '../containers/dossier-details/tabs/clarification/DossierDetailClarification';
import DossierDetailCasetafel from '../containers/dossier-details/tabs/DossierDetailCasetafel';
import DossierDetailCommission from '../containers/dossier-details/tabs/DossierDetailCommission';
import DossierDetailOverview from '../containers/dossier-details/tabs/DossierDetailOverview';
import DossierDetailProcedure from '../containers/dossier-details/tabs/DossierDetailProcedure';
import DossierDetailRequest from '../containers/dossier-details/tabs/DossierDetailRequest';
import DossierDetailContactMoments from '../containers/dossier-details/tabs/DossierDetailContactMoments';
import { PERMISSIONS } from './permissions.constants';
import { DOSSIER_TYPES } from './settings.constants';
import DossierDetailRelated from '../containers/dossier-details/tabs/DossierDetailRelated';
import DossierDetailAttachments from '../containers/dossier-details/tabs/DossierDetailAttachments';

export const ROOT_PATH = '/';
export const LOGIN_PATH = '/login';
export const LOGIN_CHOOSE_METHOD_PATH = '/login/methode';
export const LOGIN_FIRST_TIME_SETUP_PATH = '/login/welkom';
export const AUTH_ERROR_PATH = '/auth/error';
export const LOGOUT_PATH = '/logout';
export const NO_PERMISSION_PATH = '/no-permission';
export const NOT_FOUND_PATH = '/not-found';

export const ADMIN_PATH = '/beheer';
export const ADMIN_TAB_PATHS = {
  CONTACTS: { path: `/personen`, name: 'Personen' },
  ORGANIZATIONS: { path: `/organisaties`, name: 'Organisaties', permission: PERMISSIONS.STAD_DISPATCH },
  TEMPLATES: { path: `/sjablonen`, name: 'Sjablonen', permission: PERMISSIONS.STAD_DISPATCH },
  THEMES: { path: `/labels`, name: 'Labels', permission: PERMISSIONS.STAD_DISPATCH },
  OFFERING: { path: `/aanbod`, name: 'Aanbod', permission: PERMISSIONS.STAD_DISPATCH },
  OFFERING_NEW: { path: `/aanbod/nieuw`, name: 'Aanbod', excludeFromNav: true, permission: PERMISSIONS.STAD_DISPATCH },
  OFFERING_DETAIL: { path: `/aanbod/:id`, name: 'Aanbod', excludeFromNav: true, permission: PERMISSIONS.STAD_DISPATCH }
};
export const ADMIN_ORGANIZATIONS_PATHS = {
  PARTNERS: { path: '/partners', name: 'Partners' },
  SCHOOLS: { path: '/scholen', name: 'Scholen' }
};
export const ADMIN_SCHOOLS_PATHS = {
  MANAGEMENT: { path: '/:netId', name: 'Schoolbesturen' },
  COMMUNITIES: { path: '/:netId/schoolbesturen/:managementId', name: 'Scholengemeenschappen' },
  SCHOOLS: { path: '/:netId/schoolbesturen/:managementId/scholengemeenschappen/:communityId', name: 'Scholen' },
  BRANCHES: {
    path: '/:netId/schoolbesturen/:managementId/scholengemeenschappen/:communityId/scholen/:schoolId',
    name: 'Vestigingen'
  },
  AGODI_BRANCHES: {
    path: '/:netId/schoolbesturen/:managementId/scholengemeenschappen/:communityId/scholen/:schoolId/vestigingen/:branchId',
    name: 'Vestigingen vanuit AGODI'
  },
  AGODI_BRANCH_DETAILS: {
    path: '/:netId/schoolbesturen/:managementId/scholengemeenschappen/:communityId/scholen/:schoolId/vestigingen/:branchId/agodi/:agodiBranchId',
    name: 'AGODI Vestiging'
  }
};
export const OFFERINGS_PATH = '/doe-je-aanvraag';
export const OFFERINGS_DETAIL_PATH = '/doe-je-aanvraag/:offeringId';
export const DOSSIERS_PATH = '/dossiers';
export const DOSSIER_DETAIL_PATH = '/dossiers/:id';
export const DOSSIER_DETAIL_TAB_PATHS = {
  OVERVIEW: {
    path: '/',
    name: 'Overzicht',
    component: DossierDetailOverview,
    dossierTypes: [DOSSIER_TYPES.PROGRAM, DOSSIER_TYPES.FINANCED_PROGRAM, DOSSIER_TYPES.ACTION],
    writePermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN }
      ],
      [DOSSIER_TYPES.ACTION]: [{ permission: PERMISSIONS.STAD_DISPATCH }, { permission: PERMISSIONS.STAD_ADMIN }]
    },
    readPermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.ACTION]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    }
  },
  REQUREST: {
    path: '/aanvraag',
    name: 'Aanvraag',
    component: DossierDetailRequest,
    dossierTypes: [DOSSIER_TYPES.PROGRAM, DOSSIER_TYPES.FINANCED_PROGRAM, DOSSIER_TYPES.ACTION],
    writePermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.ACTION]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    },
    readPermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.ACTION]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    }
  },
  CLARIFICATION: {
    path: '/vraagverheldering',
    name: 'Vraagverheldering',
    component: DossierDetailClarification,
    dossierTypes: [DOSSIER_TYPES.PROGRAM],
    writePermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT, onlyIfStakeholderInTab: true }
      ]
    },
    readPermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    }
  },
  CASETAFEL: {
    path: '/casetafel',
    name: 'Casetafel',
    component: DossierDetailCasetafel,
    dossierTypes: [DOSSIER_TYPES.PROGRAM],
    writePermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT, onlyIfStakeholderInTab: true }
      ]
    },
    readPermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    }
  },
  COMMISSION: {
    path: '/commissie',
    name: 'Commissie',
    component: DossierDetailCommission,
    dossierTypes: [DOSSIER_TYPES.FINANCED_PROGRAM],
    writePermissions: {
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT, onlyIfStakeholderInTab: true }
      ]
    },
    readPermissions: {
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    }
  },
  PROCEDURE: {
    path: '/opvolging',
    name: 'Opvolging',
    component: DossierDetailProcedure,
    dossierTypes: [DOSSIER_TYPES.PROGRAM, DOSSIER_TYPES.FINANCED_PROGRAM, DOSSIER_TYPES.ACTION],
    writePermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT, onlyIfStakeholderInTab: true }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT, onlyIfStakeholderInTab: true }
      ],
      [DOSSIER_TYPES.ACTION]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER, onlyIfStakeholderInTab: true },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    },
    readPermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.ACTION]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    }
  },
  CONTACT_MOMENTS: {
    path: '/contactmomenten',
    name: 'Contactmomenten',
    component: DossierDetailContactMoments,
    dossierTypes: [DOSSIER_TYPES.PROGRAM, DOSSIER_TYPES.FINANCED_PROGRAM, DOSSIER_TYPES.ACTION],
    writePermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.ACTION]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    },
    readPermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.ACTION]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    }
  },
  RELATED: {
    path: '/gerelateerd',
    name: 'Gerelateerd',
    component: DossierDetailRelated,
    dossierTypes: [DOSSIER_TYPES.PROGRAM, DOSSIER_TYPES.FINANCED_PROGRAM, DOSSIER_TYPES.ACTION],
    writePermissions: {
      [DOSSIER_TYPES.PROGRAM]: [{ permission: PERMISSIONS.STAD_DISPATCH }, { permission: PERMISSIONS.STAD_ADMIN }],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [{ permission: PERMISSIONS.STAD_DISPATCH }],
      [DOSSIER_TYPES.ACTION]: [{ permission: PERMISSIONS.STAD_DISPATCH }]
    },
    readPermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.ACTION]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    }
  },
  ATTACHMENTS: {
    path: '/bijlagen',
    name: 'Alle Bijlagen',
    component: DossierDetailAttachments,
    dossierTypes: [DOSSIER_TYPES.PROGRAM, DOSSIER_TYPES.FINANCED_PROGRAM, DOSSIER_TYPES.ACTION],
    writePermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.ACTION]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    },
    readPermissions: {
      [DOSSIER_TYPES.PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.FINANCED_PROGRAM]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ],
      [DOSSIER_TYPES.ACTION]: [
        { permission: PERMISSIONS.STAD_DISPATCH },
        { permission: PERMISSIONS.STAD_ADMIN },
        { permission: PERMISSIONS.SCHOOL_ADMIN },
        { permission: PERMISSIONS.SCHOOL_MEDEWERKER },
        { permission: PERMISSIONS.SCHOOL_NET_ADMIN },
        { permission: PERMISSIONS.SCHOOL_NET_BEGELEIDER },
        { permission: PERMISSIONS.PARTNER_ADMIN },
        { permission: PERMISSIONS.PARTNER_MEDEWERKER },
        { permission: PERMISSIONS.PARTNER_NIET_FREQUENT }
      ]
    }
  }
};
export const DOSSIER_DETAIL_TAB_PATHS_BY_TYPE = {
  [DOSSIER_TYPES.PROGRAM]: {
    OVERVIEW: DOSSIER_DETAIL_TAB_PATHS.OVERVIEW,
    REQUREST: DOSSIER_DETAIL_TAB_PATHS.REQUREST,
    CLARIFICATION: DOSSIER_DETAIL_TAB_PATHS.CLARIFICATION,
    CASETAFEL: DOSSIER_DETAIL_TAB_PATHS.CASETAFEL,
    PROCEDURE: DOSSIER_DETAIL_TAB_PATHS.PROCEDURE,
    CONTACT_MOMENTS: DOSSIER_DETAIL_TAB_PATHS.CONTACT_MOMENTS,
    RELATED: DOSSIER_DETAIL_TAB_PATHS.RELATED,
    ATTACHMENTS: DOSSIER_DETAIL_TAB_PATHS.ATTACHMENTS
  },
  [DOSSIER_TYPES.FINANCED_PROGRAM]: {
    OVERVIEW: DOSSIER_DETAIL_TAB_PATHS.OVERVIEW,
    REQUREST: DOSSIER_DETAIL_TAB_PATHS.REQUREST,
    COMMISSION: DOSSIER_DETAIL_TAB_PATHS.COMMISSION,
    PROCEDURE: DOSSIER_DETAIL_TAB_PATHS.PROCEDURE,
    CONTACT_MOMENTS: DOSSIER_DETAIL_TAB_PATHS.CONTACT_MOMENTS,
    RELATED: DOSSIER_DETAIL_TAB_PATHS.RELATED,
    ATTACHMENTS: DOSSIER_DETAIL_TAB_PATHS.ATTACHMENTS
  },
  [DOSSIER_TYPES.ACTION]: {
    OVERVIEW: DOSSIER_DETAIL_TAB_PATHS.OVERVIEW,
    REQUREST: DOSSIER_DETAIL_TAB_PATHS.REQUREST,
    PROCEDURE: DOSSIER_DETAIL_TAB_PATHS.PROCEDURE,
    CONTACT_MOMENTS: DOSSIER_DETAIL_TAB_PATHS.CONTACT_MOMENTS,
    RELATED: DOSSIER_DETAIL_TAB_PATHS.RELATED,
    ATTACHMENTS: DOSSIER_DETAIL_TAB_PATHS.ATTACHMENTS
  }
};
export const DOSSIER_DETAIL_OVERVIEW_PATH = '/dossiers/:id/overzicht';
export const DOSSIER_DETAIL_REQUEST_PATH = '/dossiers/:id/aanvraag';
export const DOSSIER_DETAIL_CLARIFICATION_PATH = '/dossiers/:id/vraagverheldering';
export const DOSSIER_DETAIL_CASETAFEL_PATH = '/dossiers/:id/casetafel';
export const DOSSIER_DETAIL_PROCEDURE_PATH = '/dossiers/:id/opvolging';
export const DOSSIER_DETAIL_CONTACT_MOMENTS_PATH = '/dossiers/:id/contactmomenten';
export const DOSSIER_DETAIL_RELATED_PATH = '/dossiers/:id/gerelateerd';
export const DOSSIER_DETAIL_ATTACHMENTS_PATH = '/dossiers/:id/bijlagen';

export const NO_AUTH_PATHS = [
  OFFERINGS_PATH,
  OFFERINGS_DETAIL_PATH,
  ROOT_PATH,
  AUTH_ERROR_PATH,
  LOGOUT_PATH,
  LOGIN_PATH,
  NO_PERMISSION_PATH,
  NOT_FOUND_PATH,
  LOGIN_CHOOSE_METHOD_PATH
];
